import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Route} from 'react-router-dom';
import PortfolioProjectPage from '../pages/PortfolioProjectPage';

// Components
import {Pages} from '../common/vars';

// Elements
import Header from  '../components/Header';
import FooterLogo from '../elements/FooterLogo';
import ProjectList from '../components/ProjectList';
import TextBlock from '../elements/TextBlock';

import {hideProject} from '../reducers/PortfolioReducer';

import '../../styles/pages/page.css';
import '../../styles/pages/portfolio.css';

class PortfolioPage extends Component {

  page = Pages[1];

  portfolio = null;

  content = this.page.content;


  componentWillUpdate(_props){
    if(_props.history.location.pathname === '/portfolio' && this.props.portfolio.projectIsVisible) {
      this.props.dispatch(hideProject());
    }
  }

  render() {
    return (
      <article className="page portfolio">
        <Header image={this.page.img} svg={this.page.svg} title={this.page.name} subtitle={this.page.subtitle}/>
        <div className="page__content">
          <TextBlock title={this.content[0].title} content={this.content[0].content}
                     className="text-block--first text-block--left text-block--small-left"/>
          <ProjectList/>
        </div>
        <FooterLogo />
        <div className={"portfolio__info" + (this.props.portfolio.projectIsVisible?' portfolio__info--visible':'')}>
          <Route path="/portfolio/:project" component={PortfolioProjectPage}/>
        </div>
      </article>
    );
  }

}

const mapStateToProps = state => {
  return {
    portfolio: state.portfolio,
  }
};

export default withRouter(connect(mapStateToProps)(PortfolioPage));


// WEBPACK FOOTER //
// ./src/js/pages/PortfolioPage.js